export const PAYMENT_EXPORT_CONFIG = {
    CHUNK_SIZE: 500,
    CHUNK_DELAY_MS: 500,
    MAX_EXPORT_LIMIT: 50000,
    SIMPLE_EXPORT_THRESHOLD: 500,
};

export const shouldUseChunkedExport = (totalCount: number): boolean => {
    return totalCount >= PAYMENT_EXPORT_CONFIG.SIMPLE_EXPORT_THRESHOLD;
};

export const calculateChunkCount = (totalCount: number): number => {
    return Math.ceil(totalCount / PAYMENT_EXPORT_CONFIG.CHUNK_SIZE);
};

export const calculateProgress = (chunkIndex: number, totalCount: number): number => {
    const loadedCount = (chunkIndex + 1) * PAYMENT_EXPORT_CONFIG.CHUNK_SIZE;
    const actualLoaded = Math.min(loadedCount, totalCount);

    return Math.round((actualLoaded / totalCount) * 100);
};
